import moment from "moment";
import { RxCluCashOpsDocument } from "../@services/m-cashdesk-core-rxdb";
import { RxCluCashOpsDocumentType } from "../@schemas/clu_cashops.schema";
import { v4 as uuidv4 } from 'uuid';

export class CluCashOpItem {

    PK_ID : string; 
    MD_SITEGID? : string; 
    MD_SITE? : string; 
    MD_CAISSE? : string; 
    MD_CAISSE_LIB? : string; 
    MD_CAISSIERGID? : string; 
    MD_CAISSIER? : string; 
    MD_CAISSIER_LIB? : string; 
    MD_CAISSE_SESSION? : string; 
    MD_LOCALGID? : string;
    MD_DATE_CREATION? : string;
    MD_CBMARQ? : number;

    EC_SENS : number = 1;
    EC_NATURE : string = '';
    EC_NATURE_LIB : string = '';
    JO_NUM : string = '';
    CG_NUM : string = '';
    CG_NUM_J : string = '';
    EC_DATE_V : Date;
    EC_DATE_ECR_V : Date;
    EC_HEURE : string;
    EC_REFERENCE? : string = '';
    EC_CATEGORIE? : string = '';
    EC_CATEGORIE_LIB? : string = '';
    EC_FLAG? : string = '';
    EC_INTITULE : string = '';
    EC_MONTANT : number = 0;
    EC_MT_IN : number = 0;
    EC_MT_OUT : number = 0;

    N_REGLEMENT : string = '';
    N_REGLEMENTLIB : string = '';

    ANA_ITEMS : CluCashOpItem_A[] = [];
    
    ZSYNCUP_FLAG : number = 0;
    ZSYNCUP_STATUS : string = '';
    ZSYNCUP_ERROR_MESSAGE : string = '';
    ZSYNCUP_DATETIME : string = '';
    ZSYNCUP_FEEDID : string = '';

    FROM_RXDOCUMENT(DOCUMENT : RxCluCashOpsDocument){
        this.PK_ID = DOCUMENT.PK_ID!;
        this.MD_SITEGID = DOCUMENT.MD_SITEGID;
        this.MD_SITE = DOCUMENT.MD_SITE;
        this.MD_CAISSE = DOCUMENT.MD_CAISSE;
        this.MD_CAISSE_LIB = DOCUMENT.MD_CAISSE_LIB;
        this.MD_CAISSIERGID = DOCUMENT.MD_CAISSIERGID;
        this.MD_CAISSIER = DOCUMENT.MD_CAISSIER;
        this.MD_CAISSIER_LIB = DOCUMENT.MD_CAISSIER_LIB;
        this.MD_CAISSE_SESSION = DOCUMENT.MD_CAISSE_SESSION;
        this.MD_LOCALGID = DOCUMENT.MD_LOCALGID;
        this.MD_DATE_CREATION = DOCUMENT.MD_DATE_CREATION;
        this.MD_CBMARQ = DOCUMENT.MD_CBMARQ;

        this.EC_SENS = parseInt(DOCUMENT.EC_SENS!);
        this.EC_NATURE = DOCUMENT.EC_NATURE!;
        this.EC_NATURE_LIB = DOCUMENT.EC_NATURE_LIB!;
        this.JO_NUM = DOCUMENT.JO_NUM!;
        this.CG_NUM = DOCUMENT.CG_NUM!;
        this.CG_NUM_J = DOCUMENT.CG_NUM_J!;
        this.EC_DATE_V = moment.utc(DOCUMENT.EC_DATE).toDate();
        this.EC_DATE_ECR_V = moment.utc(DOCUMENT.EC_DATE_ECR).toDate();
        this.EC_HEURE = moment.utc(DOCUMENT.EC_DATE).format('HH:mm:ss');
        this.EC_REFERENCE = DOCUMENT.EC_REFERENCE;
        this.EC_CATEGORIE = DOCUMENT.EC_CATEGORIE;
        this.EC_CATEGORIE_LIB = DOCUMENT.EC_CATEGORIE_LIB;
        this.EC_FLAG = DOCUMENT.EC_FLAG;
        this.EC_INTITULE = DOCUMENT.EC_INTITULE!;
        this.EC_MONTANT = DOCUMENT.EC_MONTANT!;
        this.EC_MT_IN = this.EC_SENS == 0 ? this.EC_MONTANT : 0;
        this.EC_MT_OUT = this.EC_SENS == 1 ? this.EC_MONTANT : 0;
        this.N_REGLEMENT = DOCUMENT.N_REGLEMENT!;
        this.N_REGLEMENTLIB = DOCUMENT.N_REGLEMENTLIB!;
        let ANA_ITEMS : CluCashOpItem_A[] = JSON.parse(DOCUMENT.ANA_ITEMS_JSON!);
        this.ANA_ITEMS = ANA_ITEMS;
        
        this.ZSYNCUP_FLAG = DOCUMENT.ZSYNCUP_FLAG!;
        this.ZSYNCUP_STATUS = DOCUMENT.ZSYNCUP_STATUS!;
        this.ZSYNCUP_ERROR_MESSAGE = DOCUMENT.ZSYNCUP_ERROR_MESSAGE!;
        this.ZSYNCUP_DATETIME = DOCUMENT.ZSYNCUP_DATETIME!;
        this.ZSYNCUP_FEEDID = DOCUMENT.ZSYNCUP_FEEDID!;
    }

    TO_RXDOCUMENT() : RxCluCashOpsDocumentType { 
        let DOCUMENT : RxCluCashOpsDocumentType = {
            PK_ID : this.PK_ID, 
            MD_SITEGID : this.MD_SITEGID, 
            MD_SITE : this.MD_SITE, 
            MD_CAISSE : this.MD_CAISSE, 
            MD_CAISSE_LIB : this.MD_CAISSE_LIB, 
            MD_CAISSIERGID : this.MD_CAISSIERGID, 
            MD_CAISSIER : this.MD_CAISSIER, 
            MD_CAISSIER_LIB : this.MD_CAISSIER_LIB, 
            MD_CAISSE_SESSION : this.MD_CAISSE_SESSION, 
            MD_LOCALGID : this.MD_LOCALGID, 
            MD_DATE_CREATION : this.MD_DATE_CREATION,
            MD_CBMARQ : this.MD_CBMARQ, 

            EC_FLAG : this.EC_FLAG,
            EC_DATE_ECR : this.EC_DATE_ECR_V.toISOString(),
            EC_DATE : this.EC_DATE_V.toISOString(),
            EC_HEURE : this.EC_HEURE,
            EC_REFERENCE : this.EC_REFERENCE,
            EC_CATEGORIE : this.EC_CATEGORIE,
            EC_CATEGORIE_LIB : this.EC_CATEGORIE_LIB,
            EC_NATURE : this.EC_NATURE,
            EC_NATURE_LIB : this.EC_NATURE_LIB,
            JO_NUM : this.JO_NUM,
            CG_NUM : this.CG_NUM,
            CG_NUM_J : this.CG_NUM_J,
            EC_INTITULE : this.EC_INTITULE,
            EC_SENS : this.EC_SENS.toString(),
            EC_MONTANT : this.EC_MONTANT,
            N_REGLEMENT : this.N_REGLEMENT,
            N_REGLEMENTLIB : this.N_REGLEMENTLIB,
            ANA_ITEMS_JSON : JSON.stringify(this.ANA_ITEMS),

            ZSYNCUP_FLAG : this.ZSYNCUP_FLAG,
            ZSYNCUP_STATUS : this.ZSYNCUP_STATUS,
            ZSYNCUP_ERROR_MESSAGE : this.ZSYNCUP_ERROR_MESSAGE,
            ZSYNCUP_DATETIME : this.ZSYNCUP_DATETIME,
            ZSYNCUP_FEEDID : this.ZSYNCUP_FEEDID
        };
        return DOCUMENT;
    }
}

export class CluCashOpItem_A {
    N_ANALYTIQUE : number;
    N_ANALYTIQUELIB : string;
    INVALID : boolean;
    ERROR_MESSAGE : string;
    EA_ROWS : CluCashOpItem_EA_ROW[] = [];
}

export class CluCashOpItem_EA_ROW {
    CA_NUM : string;
    CA_REPART_DEFAULT : number;
    EA_MONTANT : number;
}
